<template>
  <div class="act-box-wrap">
    <div class="banner-wrap">
      <img src="../img/joinUs/banner.jpg" alt="猎上合伙人 招募正式开启" width="100%" />
    </div>
    <div class="box-01">
      <h2 class="title">猎上网平台能力</h2>
      <ul class="box-con">
        <li>
          <img src="../img/joinUs/0-1.png" alt="大流量" />
          <b>大流量</b>
          <p>行业内用户规模最大平台，累计注册猎头顾问规模超40万人。</p>
        </li>
        <li>
          <img src="../img/joinUs/0-2.png" alt="大品牌" />
          <b>大品牌</b>
          <p>行业内最知名猎头服务平台，覆盖行业数与服务客户数，绝对领先。</p>
        </li>
        <li>
          <img src="../img/joinUs/0-3.png" alt="大资金" />
          <b>大资金</b>
          <p>知名投资基金青睐，自身造血盈利能力强，业务现金流稳定充裕。</p>
        </li>
      </ul>
    </div>
    <div class="box-02">
      <h2 class="title">加盟价值</h2>
      <ul class="box-con">
        <li>
          <img src="../img/joinUs/1-1.png" alt="提升存量岗位成单率" />
          <b>提升存量岗位成单率</b>
          <p>通过加盟建立运营团队，聚焦运营自有存量岗位，提升岗位成单率。</p>
        </li>
        <li>
          <img src="../img/joinUs/1-2.png" alt="提升顾问留存率" />
          <b>提升顾问留存率</b>
          <p>
            通过加盟撬动猎上大平台强大的BD能力和海量的顾问流量资源，提升顾问产出能力与留存率。
          </p>
        </li>
        <li>
          <img src="../img/joinUs/1-3.png" alt="提升收入规模" />
          <b>提升收入规模</b>
          <p>
            平台合伙人经过3个月成长期，即可达年GMV500万，净利润30万/年，相当于培养了3个顾问。
          </p>
        </li>
      </ul>
    </div>
    <div class="box-03">
      <h2 class="title">加盟赋能</h2>
      <ul class="box-con">
        <li>
          <img src="../img/joinUs/2-1.png" alt="资源" />
          <b>资源</b>
          <p>以猎上网强大的BD能力为依托，实现行业全面覆盖，岗位海量供给。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-2.png" alt="流量" />
          <b>流量</b>
          <p>
            猎上平台行业知名度高，顾问渗透率高，用户基础规模全行业遥遥领先。
          </p>
        </li>
        <li>
          <img src="../img/joinUs/2-3.png" alt="培训" />
          <b>培训</b>
          <p>加盟后全面的知识与系统培训，深度的一对一带教，保证成长质量。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-4.png" alt="职场" />
          <b>职场</b>
          <p>重点城市产业合作资质，优质办公场所免费入驻。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-5.png" alt="金融" />
          <b>金融</b>
          <p>更灵活的税优解决方案，优秀合伙人享受总部资金支持。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-6.png" alt="数据" />
          <b>数据</b>
          <p>精准的数据回收与分析能力，全面助力合伙人运营能力提升。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-7.png" alt="系统" />
          <b>系统</b>
          <p>覆盖全业务流程的业务系统支持，让科学管理，提升做单效率。</p>
        </li>
        <li>
          <img src="../img/joinUs/2-8.png" alt="品牌" />
          <b>品牌</b>
          <p>行业头部品牌效应，助力合伙人BD、招聘效率提升。</p>
        </li>
      </ul>
    </div>
    <div class="box-04">
      <h2 class="title">加盟问答</h2>
      <div class="qa-con">
        <p>Q1：加盟猎上PA合伙人需要收取费用吗?</p>
        <p>A1：目前加盟猎上PA合伙人，猎上平台不收入任何费用。</p>
      </div>
      <div class="qa-con">
        <p>Q2：加盟PA合伙人有公司规模限制吗?</p>
        <p>
          A2：目前加盟猎上PA合伙人没有公司规模限制，有经验的个人顾问，也可申请成为平台PA合伙人。
        </p>
      </div>
      <div class="qa-con">
        <p>Q3：加盟之后会有专人培训吗?</p>
        <p>
          A3：不仅会有专人的专场培训，我们还选择了业务精英作为一对一带教的老师，快速帮助您熟悉业务和系统，快速产出。
        </p>
      </div>
    </div>
    <div class="box-05">
      <h2 class="title">加盟流程</h2>
      <ul class="box-con">
        <li>
          <img src="../img/joinUs/4-1.png" alt="加盟咨询" />
          <p>加盟咨询</p>
          <i>1</i>
        </li>
        <li>
          <i>2</i>
          <img src="../img/joinUs/4-2.png" alt="意向申请" />
          <p>意向申请</p>
        </li>
        <li>
          <img src="../img/joinUs/4-3.png" alt="资格遴选" />
          <p>资格遴选</p>
          <i>3</i>
        </li>
        <li>
          <i>4</i>
          <img src="../img/joinUs/4-4.png" alt="公司面谈" />
          <p>公司面谈</p>
        </li>
        <li>
          <img src="../img/joinUs/4-5.png" alt="合同签约" />
          <p>合同签约</p>
          <i>5</i>
        </li>
        <li>
          <i>6</i>
          <img src="../img/joinUs/4-6.png" alt="360培训" />
          <p>360培训</p>
        </li>
        <li>
          <img src="../img/joinUs/4-7.png" alt="一对一带教" />
          <p>一对一带教</p>
          <i>7</i>
        </li>
        <li>
          <i>8</i>
          <img src="../img/joinUs/4-8.png" alt="业绩产出" />
          <p>
            业绩产出
            <span>(2-3个月后)</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="box-06">
      <div class="box-con">
        <h2 class="title">合伙人案例</h2>
        <img src="../img/joinUs/pic-3.png" alt="" />
        <p>成功的硬币，一面是努力，一面是选择｜猎上网合伙人李劲夫的故事</p>
        <a href="https://mp.weixin.qq.com/s/V9UBaWogGiTzWJb9qPKGAg" class="link"
          >查看详情 >></a
        >
      </div>
    </div>
    <div class="box-07">
      <div class="box-con">
        <div class="join-form-wrap">
          <img src="../img/joinUs/icon-email.png" class="mail" alt="我要加盟" />
          <h2 class="title">我要加盟</h2>
          <form>
            <ul>
              <li class="icon-name">
                <van-field
                  v-model="form.userName"
                  maxlength="20"
                  placeholder="请输入姓名"
                />
              </li>
              <li class="icon-phone">
                <van-field
                  v-model="form.mobilePhone"
                  maxlength="11"
                  placeholder="请输入手机号"
                />
              </li>
              <li class="icon-city">
                <van-field
                  v-model="area"
                  @click="showPickerAddr = true"
                  clickable
                  readonly
                  placeholder="请选择城市"
                >
                </van-field>
              </li>
            </ul>
            <a href="javascript:;" class="btn-submit" @click="submit">提交</a>
          </form>
        </div>
        <img src="../img/logo-w.png" class="logo" alt="猎上网" />
        <p class="tips">021-80254514（加盟咨询）</p>
      </div>
    </div>
    <div class="box-08">
      <img src="../img/joinUs/pic-5.png" alt="加盟咨询">
    </div>
    <!-- 城市 -->
    <van-popup v-model="showPickerAddr" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsAddr"
        @cancel="showPickerAddr = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.act-box-wrap {
  min-height: 100%;
  background: #e9523b;
  overflow: hidden;
  .banner-wrap {
    text-align: center;
  }
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
  }
  .box-con {
    padding: 0 15px;
    margin: 0 auto;
    li {
      color: #666;
      line-height: 24px;
      font-size: 13px;
      font-family: PingFangSC-Regular;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
      img {
        margin-top: -5px;
      }
      b {
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 5px;
        margin-left: 5px;
        display: inline-block;
      }
    }
  }
  .box-01 {
    background-color: #fff;
    padding: 20px 0;
    b {
      color: #333;
    }
    img {
      width: 20px;
    }
  }
  .box-02 {
    background: url("../img/joinUs/pic-1.png") no-repeat;
    background-size: cover;
    padding: 20px 0;
    .title {
      color: #fff;
      position: relative;
      margin-bottom: 22px;
      &::after {
        content: "";
        display: block;
        width: 30px;
        height: 3px;
        background: #e9523b;
        border-radius: 2px;
        margin: 0 auto;
      }
    }
    .box-con {
      li,
      b {
        color: #fff;
      }
      b {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        margin-bottom: 0;
      }
      img {
        width: 25px;
      }
      p {
        padding-left: 30px;
      }
    }
  }
  .box-03 {
    background-color: #fff;
    padding-top: 20px;
    .box-con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        color: #666;
        min-width: 35%;
        flex: 1;
        margin: 0;
        margin-bottom: 20px;
        text-align: center;
        &:nth-child(2n) {
          margin-left: 25px;
        }
        img {
          height: 35px;
        }
        b {
          color: #333;
          font-weight: bold;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          margin: 10px auto 0;
          display: block;
        }
        p {
          text-align: left;
        }
      }
    }
  }
  .box-04 {
    padding: 20px 0 30px;
    background: url("../img/joinUs/pic-2.png") center top no-repeat;
    background-size: cover;
    background-color: #e1513b;
    .title {
      color: #fff;
    }
    .qa-con {
      color: #fff;
      padding: 0 20px;
      margin: 0 auto 20px;
      p {
        font-size: 13px;
        line-height: 24px;
        &:not(:last-child) {
          margin-bottom: 5px;
        }
      }
    }
  }
  .box-05 {
    padding: 30px 0 40px;
    background-color: #fff;
    .box-con {
      position: relative;
      overflow: hidden;
      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 500px;
        background-color: #ddd;
        position: absolute;
        left: 50%;
        top: 0;
        z-index: 1;
      }
      li {
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 50%;
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        &:nth-child(2n) {
          justify-content: flex-end;
          margin-left: auto;
          img {
            margin-left: 0;
          }
          p {
            margin-right: auto;
          }
          i {
            margin-left: -11px;
            margin-right: 10px;
          }
        }
        img {
          height: 24px;
          margin-right: 5px;
          margin-left: auto;
          margin-top: 0;
        }
        p {
          font-size: 14px;
          color: #333;
          height: 24px;
          span {
            font-size: 10px;
          }
        }
        i {
          display: inline-block;
          background: #dc2b21;
          color: #fff;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          width: 22px;
          line-height: 22px;
          border-radius: 50%;
          text-align: center;
          font-style: normal;
          margin-left: 10px;
          margin-right: -11px;
        }
      }
    }
  }
  .box-06 {
    padding: 30px 0;
    background-color: #fff;
    .title {
      margin-bottom: 15px;
    }
    .box-con {
      img {
        width: 100%;
      }
      p {
        font-size: 14px;
        margin: 10px auto;
      }
      .link {
        display: block;
        line-height: 24px;
        background: #e9523b;
        border-radius: 2px;
        padding: 0 10px;
        font-size: 12px;
        color: #ffffff;
        font-weight: 600;
        width: 90px;
        margin: 0 auto;
        font-family: PingFangSC-Regular;
        &:hover {
          text-decoration: none;
          opacity: 0.9;
        }
      }
    }
  }
  .box-07 {
    padding: 20px 0 40px;
    background: url("../img/joinUs/pic-4.png") center top no-repeat;
    background-size: cover;
    .title {
      color: #fff;
      margin-bottom: 15px;
    }
    .join-form-wrap {
      .mail {
        display: block;
        width: 30px;
        margin: 0 auto 5px;
      }
      li {
        margin-bottom: 15px;
        .van-cell {
          border-radius: 4px;
          padding-left: 56px;
          background-repeat: no-repeat;
          background-position: 18px center;
          background-size: 20px auto;
        }
        &.icon-name .van-cell {
          background-image: url("../img/joinUs/5-1.png");
        }
        &.icon-phone .van-cell {
          background-image: url("../img/joinUs/5-2.png");
        }
        &.icon-city .van-cell {
          background-image: url("../img/joinUs/5-3.png");
        }
      }
      .btn-submit {
        display: block;
        color: #fff;
        height: 44px;
        line-height: 44px;
        background: #dc2b21;
        border-radius: 4px;
        text-align: center;
        width: 100%;
        border: 0;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        &:hover {
          opacity: 0.9;
        }
      }
    }
    .logo {
      display: block;
      height: 30px;
      margin: 30px auto 15px;
    }
    .tips {
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #dc2b21;
      letter-spacing: 0;
      text-align: center;
      line-height: 30px;
      font-weight: 600;
    }
  }
  .box-08{
    background-color: #fff;
    padding: 5px 15px;
    img{
      width:100%
    }
  }
}
</style>
<style lang="scss">
.join-form-wrap {
  li {
  }
}
</style>
<script>
import { userJoinIn } from "@/api/acts";
import { isMobile } from "@/common/utils";
import { mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      showPickerAddr: false,
      province: null,
      citys: null,
      area: "",
      columnsAddr: [],
      form: {
        userName: "",
        mobilePhone: "",
        cityId: "",
      },
    };
  },
  computed: {
    ...mapState({
      cities: (state) => state.comp.cities || {},
    }),
  },
  methods: {
    onConfirm(values) {
      this.form.cityId = values[1].id.toString();
      this.area = values[0].name + " " + values[1].name;
      this.showPickerAddr = false;
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0].id]);
    },
    setCities() {
      this.province = window.METADATA.province;
      this.citys = window.METADATA.areaList.city_list;
      this.columnsAddr = [
        {
          values: this.province,
          className: "column1",
        },
        {
          values: this.citys[this.province[0].id],
          className: "column2",
          defaultIndex: 0,
        },
      ];
    },
    checkRegInfo() {
      if (!this.form.userName.trim()) {
        this.$toast("请填写姓名");
        return;
      }
      if (!this.form.mobilePhone.trim()) {
        this.$toast("请填写手机号");
        return;
      }
      if (!isMobile(this.form.mobilePhone.trim())) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (!this.form.cityId.trim()) {
        this.$toast("请选择城市");
        return;
      }

      return true;
    },
    submit() {
      if (this.checkRegInfo()) {
        userJoinIn(this.form)
          .then((res) => {
            if (res) {
              this.$toast("提交成功");
              setTimeout(() => {
                window.scrollTo(0, 0);
                this.$router.go(0);
              }, 1000);
            }
          })
          .catch((err) => {});
      }
    },
    setCookie(){
      const token = this.$route.query.token;
      Cookies.set('mp_token',token);
      Cookies.set('userId','151612');
    },
  },
  watch: {
    cities() {
      this.setCities();
    },
  },
  created() {
    // this.setCookie();
    if (window.METADATA.areaList) {
      this.setCities();
    }
    this.$store.commit("comp/WX_SHARE", {
      title: "加盟合作",
      desc: "猎上合伙人 招募正式开启",
      // link: "", 分享的link，默认是 当前url
      // imgUrl: hhLogo, 必须是 http 链接的图片
    });
  },
};
</script>
